// Traverse data modes (docs/traverse/CONTRACT.md). Every new screen reads and
// writes through one module per area in public/data/; this says, per AREA,
// whether that module serves the demo fixtures or Firestore.
//
// An area moves to 'firestore' when the backend terminal lists it under
// "Backend ready" in CONTRACT.md — one line here, never a per-screen switch.
// A developer can override one area for a session:
//   localStorage['traverse.data.time'] = 'firestore'
export const AREAS = ['org', 'time', 'tasks', 'catalogue', 'quotes', 'costs', 'team', 'settings', 'help'];

const DEFAULTS = {
  org: 'firestore',      // name, template, logo path: org.js already reads them
  time: 'firestore',     // Backend ready · time and check-in (wave1-2-areas, 22/10/2026)
  tasks: 'firestore',    // Backend ready · task review with photos (wave1-2-areas, 22/10/2026)
  catalogue: 'firestore', // Backend ready · catalogue on dated prices (functions/catalogue.js; live v4.0.1, 23/10/2026)
  quotes: 'firestore',    // Backend ready · quotes on enquiries + measuring (functions/quotes.js; live v4.0.1)
  costs: 'firestore',     // Backend ready · projects/{id}/money/costs (functions/project-costs.js; live v4.0.1)
  team: 'firestore',     // Backend ready · sign-in and team (wave1-1-signin, 22/10/2026)
  settings: 'firestore', // Owner-only saves: functions/org-settings.js (23/10/2026)
  help: 'fixtures',
};

export function modeFor(area) {
  try {
    const o = localStorage.getItem(`traverse.data.${area}`);
    if (o === 'fixtures' || o === 'firestore') return o;
  } catch (_) { /* private window */ }
  // The stand-in is the demo company end to end: its Firestore stand-ins are
  // ASP's sample, so a live area there would mix the two.
  if (standIn() && area !== 'org') return 'fixtures';
  return DEFAULTS[area] || 'fixtures';
}

// WHAT A REAL COMPANY SEES (Karan 22/10/2026; wave 2 switched on 23/10/2026,
// v4.0.1). The demo fixtures are for the stand-in only (/_track.html and the
// preview build, where _org-mock.js sets __TRACK_STAND_IN). A real company
// never sees them: an area still on fixtures shows "coming soon" instead
// (views/coming-soon.js). Wave 2 (quotes, catalogue, costs) is live now, so it
// follows its mode like every other area; whether a company USES it is its
// feature switch (Settings › What you use), which hides it from the rail.
export const WAVE2 = ['quotes', 'catalogue', 'costs'];
export const standIn = () => !!globalThis.__TRACK_STAND_IN;
export function comingSoon(area) {
  if (standIn()) return false;
  return modeFor(area) !== 'firestore';
}

let fx = null;
/** The demo company (public/fixtures/demo-contractor.json), fetched once. */
export function fixtures() {
  // Outside the stand-in there is no demo company: an area still on fixtures
  // reads as empty, so a real company sees its own empty screens, never 1042
  // "14 Elm Road" (seen on Test Contractor Ltd's phone Today, 22/10/2026).
  if (!standIn()) return Promise.resolve({});
  if (!fx) fx = fetch('/fixtures/demo-contractor.json').then((r) => (r.ok ? r.json() : {})).catch(() => ({}));
  return fx;
}
